let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6e2p1")).then(() => parcelRequire('kxhT2'));